// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"23":"countryMap","72":"earthText"}[chunkId] || chunkId) + "." + {"23":"82aa04d1","31":"eff58b0f","72":"b1a1847b","940":"d4b96325","968":"0262e945"}[chunkId] + ".js";
};